/*External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { ApproveDeviceActions, ApproveDeviceActionTypes } from './action';
import { Device } from '../../createDevice/redux/action';

export interface ApproveDeviceState {
  isApproveDeviceLoading: boolean;
  isDeviceApproved: boolean;
  device: Device;
  approveDeviceError: string;
}

export const initialApproveDeviceState: ApproveDeviceState = {
  isApproveDeviceLoading: false,
  isDeviceApproved: false,
  device: {
    id: '',
    __typename: '',
    approvalsCount: 0,
    address: '',
    location: {
      lat: 0,
      lon: 0,
    },
    notes: '',
    organization: '',
    registrationDate: '',
    status: '',
    user: {
      id: '',
    },
  },
  approveDeviceError: '',
};

export function approveDeviceReducer(state = initialApproveDeviceState, action: ApproveDeviceActions) {
  switch (action.type) {
    case ApproveDeviceActionTypes.APPROVE_DEVICE_REQUEST:
      return update(state, {
        isApproveDeviceLoading: { $set: true },
      });
    case ApproveDeviceActionTypes.APPROVE_DEVICE_SUCCEEDED:
      return update(state, {
        isApproveDeviceLoading: { $set: false },
        isDeviceApproved: { $set: true },
        device: { $set: action.device },
      });
    case ApproveDeviceActionTypes.APPROVE_DEVICE_FAILED:
      return update(state, {
        isApproveDeviceLoading: { $set: false },
        approveDeviceError: { $set: action.error.message },
      });
    case ApproveDeviceActionTypes.RESET_APPROVE_DEVICE:
      return update(state, {
        isDeviceApproved: { $set: false },
        approveDeviceError: { $set: '' },
      });
    default:
      return state;
  }
}
